import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { API_URL } from '../config';

const DealerContext = createContext(null);


export const DealerProvider = ({ children }) => {
  const [dealer, setDealer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('dealer_token'));

  const fetchMe = useCallback(async (t) => {
    try {
      const res = await fetch(`${API_URL}/api/dealer-auth/me`, {
        headers: { 'Authorization': `Bearer ${t}` },
      });
      if (res.ok) {
        const data = await res.json();
        setDealer(data);
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }, []);

  useEffect(() => {
    const init = async () => {
      if (token) {
        const ok = await fetchMe(token);
        if (!ok) {
          localStorage.removeItem('dealer_token');
          setToken(null);
          setDealer(null);
        }
      }
      setLoading(false);
    };
    init();
  }, [token, fetchMe]);

  const login = async (loginStr, password) => {
    let res;
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000);
      res = await fetch(`${API_URL}/api/dealer-auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login: loginStr, password }),
        signal: controller.signal,
      });
      clearTimeout(timeoutId);
    } catch (fetchErr) {
      if (fetchErr.name === 'AbortError') {
        throw new Error('Сервер не отвечает. Проверьте интернет-соединение и попробуйте снова.');
      }
      throw new Error('Не удалось подключиться к серверу. Проверьте интернет-соединение.');
    }
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Login failed');
    localStorage.setItem('dealer_token', data.token);
    setToken(data.token);
    setDealer(data.dealer);
    return data.dealer;
  };

  const logout = async () => {
    try {
      await fetch(`${API_URL}/api/dealer-auth/logout`, { method: 'POST' });
    } catch {}
    localStorage.removeItem('dealer_token');
    setToken(null);
    setDealer(null);
  };

  return (
    <DealerContext.Provider value={{ dealer, loading, token, login, logout }}>
      {children}
    </DealerContext.Provider>
  );
};

export const useDealer = () => {
  const ctx = useContext(DealerContext);
  if (!ctx) throw new Error('useDealer must be inside DealerProvider');
  return ctx;
};
